<template>
    <div class="vx-card p-6">
        <h3>Thông tin gói của Chi nhánh</h3>
        <div class="vx-row mt-4">
            <div class="vx-col md:w-1/4 w-full">
                <label class="vs-input--label">Chi nhánh</label>
                <v-select class="w-full" v-model="selectedBranch" :options="branchOptions" :clearable="false"
                          name="branch"
                          v-validate="'required'" :disabled="isUpdate">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('branch') }}</span>
            </div>
            <div class="vx-col md:w-1/4 w-full">
                <label class="vs-input--label">Phòng ban</label>
                <v-select class="w-full" v-model="selectedDepartment" :options="departmentOptions" :clearable="false"
                          name="departmentName" v-validate="'required'" :disabled="isUpdate">
                    <span slot="no-options"> {{ $t('menuOrganization.noOption') }}</span>
                </v-select>
                <span class="text-danger text-sm">{{ errors.first('departmentName') }}</span>
            </div>
            <div class="vx-col md:w-1/2 w-full float-right">
                <div class="mt-4 flex flex-wrap mb-5">
                    <vs-button class="ml-auto mt-2" iconPack="feather" icon="icon-check" @click="saveChanges"
                               :disabled="!validateForm" v-if="isPermissionAddService">Cập nhật
                    </vs-button>
                    <vs-button class="ml-4 mt-2" type="border" color="warning" iconPack="feather"
                               icon="icon-corner-up-left" onclick="history.back()">Quay lại
                    </vs-button>
                </div>
            </div>
        </div>
        <div class="vx-row mt-4">
            <div class="vx-col w-full">
                <v-tree ref='tree' @node-select="saveNodeSelected" @node-check="saveNodeSelected" :data='treeData'
                        :multiple="true" :halfcheck='true'/>
            </div>
        </div>
    </div>
</template>

<script>

import Vue from 'vue'
import vSelect from 'vue-select';
import {VTree} from 'vue-tree-halower';
import {isAPI, isRouter} from "../../../../store/permission";
import {constAPI, constRouter} from "../../../../store/constant";

Vue.use(VTree)

export default {
    data() {
        return {
            branchOptions: [],
            departmentOptions: [],
            treeData: [{
                title: "Danh sách dịch vụ",
                expanded: true,
                children: []
            }],
            serviceData: null,
            selectedBranchValue: null,
            selectedDepartmentValue: null,
            beautyServicePackageIds: [],
            isUpdate: false,
            beautyServiceRequestDTOS: [],
            beautyServicePackageInfo: null,
        }
    },

    components: {
        vSelect
    },

    async created() {
        let branchList = JSON.parse(localStorage.getItem('branchInfoList') || '[]');
        this.branchOptions = branchList.map(x => {
            return {label: x.organizationBranchName, value: x.id}
        });

        let departmentId = this.$route.query.departmentId;
        let organizationBranchId = this.$route.query.organizationBranchId
        if (departmentId && organizationBranchId) {
            await this.getDepartment();
            this.selectedBranchValue = parseInt(organizationBranchId);
            this.selectedDepartmentValue = parseInt(departmentId);
            this.isUpdate = true;
            await this.findSelectNodeById();
        } else {
            this.selectedBranch = this.branchOptions[0];
        }
        await this.getAllService();
    },

    computed: {
        validateForm() {
            return !this.errors.any();
        },
        selectedBranch: {
            get() {
                return {
                    label: this.getLabelString(this.branchOptions.find(x => x.value === this.selectedBranchValue)),
                    value: this.branchOptions.find(x => x.value === this.selectedBranchValue)
                }
            },
            set(obj) {
                this.selectedBranchValue = obj ? obj.value : null;
                this.getDepartment();
            }
        },

        selectedDepartment: {
            get() {
                let obj = this.departmentOptions.find(x => x.value === this.selectedDepartmentValue);
                if (!obj) return;
                return {
                    value: obj.value,
                    label: obj.label
                }
            },
            async set(obj) {
                this.selectedDepartmentValue = obj ? obj.value : null;
                await this.findSelectNodeById();
                await this.getAllService();
            }
        }
    },

    methods: {
        isPermissionAddService() {
            return isAPI(this, constAPI.department_add_service)
        },
        getLabelString(object) {
            return (object && object.label) || 'Chưa xác định';
        },
        saveNodeSelected() {
            let listNodesSelected = [];
            if (this.$refs.tree) {
                listNodesSelected = this.$refs.tree.getCheckedNodes();
            }

            this.beautyServicePackageIds = [];
            this.beautyServiceRequestDTOS = [];
            listNodesSelected.forEach(per => {
                if (per.beautyServiceId) {
                    let result = this.serviceData.find(x => x.id === per.beautyServiceId);
                    let resultPacks = result.beautyServicePackages.map(x => x.id)
                    delete result['imageStores'];
                    this.beautyServicePackageIds.push(per.id);
                    result['beautyServicePackageIds'] = this.beautyServicePackageIds.filter(x => resultPacks.includes(x));
                    this.beautyServiceRequestDTOS = this.beautyServiceRequestDTOS.filter(x => x.id !== result.id);
                    this.beautyServiceRequestDTOS.push(result);
                }
            })
        },

        getDepartment() {
            return new Promise((resolve, reject) => {
                let payload = {
                    organizationBranchId: this.selectedBranchValue,
                }

                this.$vs.loading();
                this.$crm.post('/department/find-by-condition', payload).then(res => {
                    this.departmentOptions = res.data.map(x => {
                        return {
                            value: x.id,
                            label: x.departmentName
                        }
                    })
                    resolve();
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject()
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getAllService() {
            return new Promise((resolve, reject) => {
                this.$vs.loading()
                this.$crm.post('/beauty-service/find-by-condition', {}).then(res => {
                    this.serviceData = res.data.content.filter(x => x.beautyServicePackages.length > 0);
                    let listGroup = this.serviceData.map(el => {
                        if (el.beautyServicePackages) {
                            el.beautyServicePackages = el.beautyServicePackages.map(x => {
                                x.beautyServiceId = el.id;
                                return x;
                            })
                        }
                        return el;
                    })
                    listGroup = [...new Set(listGroup)];
                    let treeDataTmp = [];

                    listGroup.forEach(q => {
                        let listChildren = q.beautyServicePackages.map(e => {
                            let checked = this.beautyServicePackageInfo ? this.beautyServicePackageInfo.some(per => per === e.id) : false;
                            return {
                                title: e.code + '-' + e.name,
                                id: e.id,
                                code: e.code,
                                name: e.name,
                                beautyServiceId: e.beautyServiceId,
                                checked,
                            }
                        })

                        treeDataTmp.push({
                            title: q.code + '-' + q.name,
                            id: q.id,
                            expanded: true,
                            children: listChildren,
                            name: q.name,
                            code: q.code,
                            description: q.description
                        })
                    });

                    this.treeData = [{
                        title: "Danh sách dịch vụ",
                        expanded: true,
                        children: [...treeDataTmp]
                    }];

                    if (this.isUpdate) {
                        let data = this.treeData[0].children;
                        data.map(el => {
                            el.beautyServicePackageIds = el.children.filter(x => x.checked).map(x => x.id);
                            return el;
                        })
                        this.beautyServiceRequestDTOS = data.filter(x => x.beautyServicePackageIds.length > 0)
                    }
                    resolve();
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject();
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        async saveChanges(evt) {
            evt.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            // if (this.beautyServiceRequestDTOS.length < 1) {
            //     return this.$vs.notify({
            //         text: 'Không được để trống trường dịch vụ!',
            //         iconPack: 'feather',
            //         icon: 'icon-alert-circle',
            //         color: 'danger'
            //     })
            // }

            let payload = {
                beautyServiceRequestDTOS: this.beautyServiceRequestDTOS,
                departmentId: this.selectedDepartmentValue,
                organizationBranchId: this.selectedBranchValue
            };

            this.$vs.loading();
            this.$crm.post('/beauty-service-package/add-service-package-department', payload).then(() => {
                this.$vs.notify({
                    text: `${this.isUpdate ? 'Cập nhật ' : 'Tạo mới '} dịch vụ cho phòng ban thành công!`,
                    iconPack: 'feather',
                    icon: 'icon-check-circle',
                    color: 'success'
                });
                this.$router.push('/user/manage-department');
                this.$vs.loading.close();
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        findSelectNodeById() {
            return new Promise((resolve, reject) => {
                let payload = {
                    departmentId: this.selectedDepartmentValue,
                    organizationBranchId: this.selectedBranchValue
                }
                this.$vs.loading();
                this.$crm.post('/beauty-service-package-department/find-by-condition', payload).then(res => {
                    this.beautyServicePackageInfo = res.data.content.map(x => x.beautyServicePackage.id);
                    resolve()
                    this.$vs.loading.close();
                }).catch((err) => {
                    reject()
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        }
    }
}
</script>

